import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from '@myapp/features/widgets/models';
import { IUserSettingsTab } from '../../models';
import { UserService } from '../../services';
import { NgFor } from '@angular/common';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { ModalWrapperComponent } from '@myapp/features/widgets/components';
import { UserSettingsTabContainerComponent } from '../user-settings-tab-container/user-settings-tab-container.component';
import { ChatPreferencesComponent } from '../../../../features/ai/chat-gpt/components/chat-preferences/chat-preferences.component';
import { InputsModule, KENDO_SLIDER } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';


@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  standalone: true,
  imports: [ModalWrapperComponent, TabStripModule, NgFor, UserSettingsTabContainerComponent,
    ChatPreferencesComponent, InputsModule, DropDownsModule
  ]
})
export class UserSettingsComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();
  private _isDirty: boolean = false;
  @Output() isDirtyChanged = new EventEmitter<boolean>();

  settingsTabs: IUserSettingsTab[] = [];
  @ViewChildren('settingsComponent') settingsComponents: UserSettingsTabContainerComponent[] = [];

  constructor(private modal: NgbActiveModal
    , private userService: UserService) {
  }

  ngOnInit(): void {
    this.settingsTabs = this.userService.getUserSettingsTabs();
  }

  dirtyChanged(_flag: boolean) {
    this.updateDirtyFlag();
  }

  private updateDirtyFlag() {
    let dirty: boolean = false;

    this.settingsComponents.forEach(tabContainer => {
      dirty ||= tabContainer.isDirty;
    });
    this.isDirty = dirty;
    this.isDirtyChanged.emit(this.isDirty);
  }

  get isDirty(): boolean {
    return this._isDirty;
  }

  private set isDirty(value: boolean) {
    this._isDirty = value;
  }

  public onCancel() {
    this.userService.cancelSettingsChanges();
    this.modal.dismiss('Cancelled');
  }

  public onSave() {
    //this.saveDirty();
    // Send save to each component in case it case custom save code.
    this.settingsComponents.forEach(tabContainer => {
      tabContainer.save();
    });

    this.userService.saveSettingsChanges();
    this.modal.close('Saved');
  }
}
